<template>
	<div class="risk_add" v-if="page === 1">
		<div class="risk_add-page1">
			<div class="risk_add-page1-content">
				<div class="risk_add-page1-content-title">
					<img src="../../assets/icon/rect.png" />
					<span>卒中复发风险警报器</span>
					<img src="../../assets/icon/rect.png" />
				</div>
				<div class="risk_add-page1-content-label">测试说明</div>
				<div class="risk_add-page1-content-text" v-for="(item,index) in page1Text" :key="index">{{item}}</div>
				<div class="risk_add-page1-content-button" @click="page = 2">确定</div>
			</div>
		</div>
	</div>
	<div class="risk_add_page2" v-else-if="page === 2">
		<div class="risk_add_page2-form">
			<div class="risk_add_page2-form-label">第{{index+1}}题</div>
			<div class="risk_add_page2-form-title">{{question.title}}</div>
			<template v-if="question.label">
				<div class="risk_add_page2-form-text" v-for="(item,index) in question.label" :key="index"
					><span>*</span>{{item}}</div
				>
			</template>
			<div class="risk_add_page2-form-content">
				<rDateTime v-model="question.value" v-if="question.type=='dateTime'" />
				<rRadio v-model="question.value" :options="question.options" v-if="question.type=='radio'" />
				<rInput :options="question.options" v-if="question.type=='input'" />
			</div>

			<div class="risk_add_page2-form-button">
				<van-row gutter="20">
					<van-col span="12">
						<van-button v-if="index != 0" type="primary" plain block @click="prev">上一题</van-button>
					</van-col>
					<van-col span="12">
						<van-button v-if="index===17" type="primary" block @click="submit">提交</van-button>
						<van-button v-else type="primary" plain block @click="next">下一题</van-button>
					</van-col>
				</van-row>
			</div>
		</div>
		<div class="risk_add_page2-tips" v-if="tips">
			<div class="risk_add_page2-tips-title">
				<img src="../../assets/img/tips-logo.png" />
				{{tips.title}}
			</div>
			<div class="risk_add_page2-tips-text">
				{{tips.label}}
			</div>
		</div>
	</div>
	<result :result="result" @back="goBack" v-else />
</template>
<script>
import form from './form'
import rDateTime from './components/risk-dateTime.vue'
import rRadio from './components/risk-radio.vue'
import rInput from './components/risk-input.vue'
import result from './detail.vue'
export default {
    components: { rDateTime, rRadio, rInput, result },
    data () {
        return {
            page: 1,
            page1Text: [
                '1.本评估软件基于2014年全球最佳医疗健康App-Stroke Riskometer应用；',
                '2.本应用可评估测试者5年内和10年内再次发生卒中的风险程度分层及相对于同龄健康人群的疾病风险倍数；',
                '3.系统将会根据测试结果进行治疗预防管理的建议。'
            ],

            index: 0,
            dataList: form.form,
            resultArr: {},
            patienDetail: {},
            obj: {
                bmi: ''
            },
            result: {}
        }
    },
    computed: {
        patientId () {
            return this.$route.params.id
        },
        question () {
            return this.dataList[this.index]
        },
        tips () {
            const { options, value, type } = this.question
            let reTips = false
            if (['radio'].indexOf(type) > -1 && value) {
                let obj = options.filter(v => v.value === value)[0]
                if (obj.tips && obj.tips.max) {
                    if (obj.tips.max <= value) {
                        reTips = obj.tips
                    }
                } else {
                    reTips = obj.tips
                }
            }
            if (this.index === 2) {
                return this.fomateBmi()
            }
            return reTips
        }
    },
    created () {
        this.getPatientInfo()
    },
    methods: {
        // 获取回显信息
        async getPatientInfo () {
            const res = await this.$api.patient.getPatientInfo(this.patientId)
            if (!res.code) {
                this.patienDetail = res.data
                this.initForm()
            }
            this.getDetail()
        },
        initForm () {
            this.dataList = form.form.map(v => ({
                ...v,
                value: this.patienDetail[v.key] || v.value,
                options: v.options.map(j => ({ ...j, value: this.patienDetail[j.key] || j.value }))
            }))
        },
        getDetail () {
            this.$api.risk.getPatientriskquestionnaire(this.patientId).then(({ data, code }) => {
                if (!code) {
                    if (data && data.content) {
                        this.result = JSON.parse(data.content)
                        this.page = 3
                    }
                }
            })
        },
        checkRisk () {
            let ret = true
            if (this.question.type === 'input') {
                let arr = this.question.options.filter(v => v.value === '')
                if (arr.length > 0) {
                    ret = false
                }
            }
            if (this.question.type === 'radio') {
                if (this.question.value === '') {
                    ret = false
                }
            }
            return ret
        },
        prev () {
            console.log(this.dataList)
            this.index -= 1
            this.resultArr[`risk${this.index}`] = ''
        },
        next () {
            if (!this.checkRisk()) {
                return
            }
            if (this.tips) {
                this.resultArr[`risk${this.index}`] = this.tips.title
            }
            this.index += 1

        },
        submit () {
            if (!this.checkRisk()) {
                return
            }
            if (this.tips) {
                this.resultArr[`risk${this.index}`] = this.tips.title
            }
            let reObj = {}
            let e = 2.71828182845904523536
            this.dataList.forEach(v => {
                if (v.key) {
                    reObj[v.key] = v.value
                }
            })
            reObj.mini_stroke = 0
            const { bmi } = this.obj
            let { gender, cigs, drink, diet, activity, stress, familys, sbp, dm, cvd, lvh, af, cognitive, injury, mini_stroke, hyprx, poor_memory } = reObj

            let _ce_age, _ce_sbp, _ce_hyprx, _ce_dm, _ce_cigs, _ce_cvd, _ce_af, _ce_lvh, _ce_inter;
            if (!sbp) {
                sbp = 0
            }
            if (sbp <= 119) {
                sbp = 119
            }
            //计算风险
            //定义常亮并赋值
            if (gender == 1) {
                //MALE CO-EFFs
                _ce_age = 0.0505;
                _ce_sbp = 0.0140;
                _ce_hyprx = 0.3263;
                _ce_dm = 0.1060;
                _ce_cigs = 0.5147;
                _ce_cvd = 0.5195;
                _ce_af = 0.6061;
                _ce_lvh = 0.8415;
            } else {
                //FEMALE CO-EFFs
                _ce_age = 0.0657;
                _ce_sbp = 0.0197;
                _ce_hyprx = 2.5432;
                _ce_inter = 0.0134;
                _ce_dm = 0.5442;
                _ce_cigs = 0.5294;
                _ce_cvd = 0.4326;
                _ce_af = 1.1497;
                _ce_lvh = 0.8488;
            }


            //BMI	VALUE
            let d33 = 1;
            let dbmi = bmi - 24;
            let _rr_bmi = 0
            if (dbmi < 0) {
                _rr_bmi = 0;
            } else {
                _rr_bmi = 0.02 * (1 + dbmi);
            }
            let age = this.dataList[0].options[0].value
            let L, base_L, M, risk5, risk10, base5, base10
            if (gender == 1) {//男性模型
                L = (age * _ce_age) +
                    (sbp * _ce_sbp) +
                    (this.formateInt(hyprx) * _ce_hyprx) +
                    (this.formateInt(dm) * _ce_dm) +
                    (this.formateInt(cigs) * _ce_cigs) +
                    (this.formateInt(cvd) * _ce_cvd) +
                    (this.formateInt(af) * _ce_af) +
                    (this.formateInt(lvh) * _ce_lvh);

                base_L = (age * _ce_age) + (119 * _ce_sbp);
                M = 5.6770;

                risk5 = 100 * (1 - Math.pow(0.9642, Math.pow(e, (L - M))));
                risk10 = 100 * (1 - Math.pow(0.9044, Math.pow(e, (L - M))));

                base5 = 100 * (1 - Math.pow(0.9642, Math.pow(e, (base_L - M))));
                base10 = 100 * (1 - Math.pow(0.9044, Math.pow(e, (base_L - M))));
            } else {//女性模型
                L = (age * _ce_age) +
                    (sbp * _ce_sbp) +
                    (this.formateInt(hyprx) * (_ce_hyprx - _ce_inter * sbp)) +
                    (this.formateInt(dm) * _ce_dm) +
                    (this.formateInt(cigs) * _ce_cigs) +
                    (this.formateInt(cvd) * _ce_cvd) +
                    (this.formateInt(af) * _ce_af) +
                    (this.formateInt(lvh) * _ce_lvh);

                base_L = (age * _ce_age) + (119 * _ce_sbp);
                M = 7.5766;

                risk5 = 100 * (1 - Math.pow(0.9741, Math.exp(L - M)));
                risk10 = 100 * (1 - Math.pow(0.9353, Math.exp(L - M)));

                base5 = 100 * (1 - Math.pow(0.9741, Math.exp(base_L - M)));
                base10 = 100 * (1 - Math.pow(0.9353, Math.exp(base_L - M)));
            }
            //5年风险
            risk5 = risk5 + (_rr_bmi + 0.2 * d33 + 0.2 * this.formateInt(diet) + 0.1 * this.formateInt(drink) + 0.1 * this.formateInt(stress) + 0.1 * this.formateInt(activity) + 0.05 * this.formateInt(familys));

            //cognitive 认知障碍
            if (cognitive) {
                risk5 = 1.8 * risk5;
            } else if (cognitive == 0 && poor_memory) {
                risk5 = 1.4 * risk5;
            }

            if (injury) {
                risk5 = 1.2 * risk5;
            }
            if (mini_stroke) {
                risk5 = risk5 + 10;
            }

            //10年风险
            risk10 = risk10 + (_rr_bmi + 0.2 * d33 + 0.2 * this.formateInt(diet) + 0.1 * this.formateInt(drink) + 0.1 * this.formateInt(stress) + 0.1 * this.formateInt(activity) + 0.05 * this.formateInt(familys));
            //cognitive 认知障碍
            if (cognitive) {
                risk10 = 1.8 * risk10;
            } else if (cognitive == 0 && poor_memory) {
                risk10 = 1.4 * risk10;
            }

            if (injury) {
                risk10 = 1.2 * risk10;
            }

            if (mini_stroke) {
                risk10 = risk10 + 15;
            }
            risk5 = parseFloat(risk5).toFixed(2);
            risk10 = parseFloat(risk10).toFixed(2);

            if (risk5 > 92.989999999999995) {
                risk5 = 92.989999999999995;
            }
            if (risk10 > 92.989999999999995) {
                risk10 = 92.989999999999995;
            }
            base5 = parseFloat(base5).toFixed(2);
            base10 = parseFloat(base10).toFixed(2);
            let bei5 = parseInt(risk5 / base5);
            let bei10 = parseInt(risk10 / base10);

            let arr = Object.values(this.resultArr)
            let result = {
                arr: arr.filter(v => v),
                obj: {
                    5: {
                        risk: risk5,
                        bei: bei5,
                        base: base5
                    },
                    10: {
                        risk: risk10,
                        bei: bei10,
                        base: base10
                    },
                }
            }
            this.$api.risk.setPatientriskquestionnaire({
                patientId: this.patienDetail.id,
                patientName: this.patienDetail.name,
                fiveStrokeProbability: risk5,
                tenStrokeProbability: risk10,
                multiplierValue: bei5,
                content: JSON.stringify(result)
            }).then(({ code }) => {
                if (!code) {
                    this.result = result
                    this.page = 3
                }

            })

        },
        goBack () {
            this.initForm()
            this.page -= 1
            this.index = 0
            this.resultArr = {}
        },
        //更新bmi
        fomateBmi () {
            const arr = this.question.options.map(v => v.value)
            let bmi = parseFloat(arr[1] / ((arr[0] * arr[0]) / 10000)).toFixed(1)
            this.obj.bmi = bmi
            return bmi >= 24 ? {
                title: '身体超重',
                label: '您应在6-12个月内减轻体重5%-10%，腰围控制在男≤90cm，女≤85cm。',
            } : false
        },
        formateInt (val) {
            return val ? 1 : 0
        }
    }
}
</script>
<style lang="less">
.risk_add {
	&-page1 {
		background: linear-gradient(180deg, #eef2f7 0%, #ebfafa 87%);
		min-height: calc(100vh - 100px);
		padding: 100px 40px 0 40px;
		&-content {
			background-color: #ffffff;
			border-radius: 38px;
			padding: 50px 36px 64px 36px;
			&-title {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 16px;
				img {
					width: 16px;
					height: 16px;
				}
				span {
					font-size: 38px;
					font-weight: bold;
					color: #0a2d2f;
					margin: 0 34px;
				}
			}
			&-label {
				text-align: center;
				font-size: 28px;
				color: #8c9d9e;
				margin-bottom: 12px;
			}
			&-text {
				margin-top: 28px;
				font-size: 30px;
				line-height: 44px;
				color: #1f2329;
				word-break: break-word;
			}
			&-button {
				background-color: @primary;
				color: #ffffff;
				border-radius: 12px;
				font-size: 34px;
				width: 320px;
				height: 88px;
				line-height: 88px;
				text-align: center;
				margin: 150px auto 0 auto;
			}
		}
	}
}
.risk_add_page2 {
	background-image: url('../../assets/img/risk-bg.png');
	background-size: 100vw 301px;
	background-repeat: no-repeat;
	background-color: #f6f6f6;
	min-height: 100vh;
	overflow: hidden;
	&-form {
		margin: 37px 32px;
		padding: 40px 30px;
		background-color: #ffffff;
		border-radius: 16px;
		&-label {
			font-size: 28px;
			font-weight: normal;
			line-height: 34px;
			letter-spacing: 0px;
			color: #656565;
		}
		&-title {
			font-size: 34px;
			font-weight: normal;
			line-height: 41px;
			letter-spacing: 0px;
			color: #333333;
			margin: 60px 0 10px 0;
		}
		&-content {
			margin-top: 60px;
		}
		&-button {
			margin-top: 50px;
		}
		&-text {
			font-size: 32px;
			font-weight: normal;
			line-height: 48px;
			span {
				color: #ea0000;
			}
		}
	}
	&-tips {
		background-image: url('../../assets/img/tips-bg.png');
		background-size: 100% 120px;
		background-repeat: no-repeat;
		background-color: #ffffff;
		border-radius: 14px;
		padding: 34px 30px;
		margin: 0 30px;
		&-title {
			font-size: 32px;
			font-weight: 500;
			color: @primary;
			display: flex;
			align-items: center;
			img {
				height: 56px;
				width: 56px;
				margin-bottom: -20px;
			}
		}
		&-text {
			font-size: 26px;
			font-weight: normal;
			line-height: 38px;
			color: #666666;
			margin-top: 30px;
		}
	}
}
</style>